<template>
  <div class="teacher-group">
    <!-- 操作栏容器 -->
    <div class="group-info-operation-container">
      <div class="notice-search">
        <search :placeholder="placeholder" @search="search" />
      </div>
      <div class="group-info-button-container">
        <!-- 新增分组 -->
        <button
          class="button add-group"
          @click="addFormShow = true"
          v-hasPermi="'sc:crowd:add'"
        >
          <i class="iconfont icon-addGlade"></i>新增分组
        </button>
        <!-- 批量删除 -->
        <button
          class="button delete-group"
          @click="deleteClick"
          v-hasPermi="'sc:crowd:delete'"
        >
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 列表栏容器 -->
    <div class="group-info-table-container" v-bitmap="groupListGetResult">
      <groupList
        class="group-list"
        :groupData="groupData"
        v-show="total"
        @multiple="multiple"
        @searchTeacher="searchTeacher"
        :teacherList="teacherList"
        :groupTypeList="groupTypeList"
        :gradeSelectList="gradeSelectList"
        :courseList="courseList"
      />
    </div>
    <!-- 分页容器 -->
    <div class="group-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageInfo.pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 添加宿舍-表单 -->
    <addGroupForm
      :addFormShow.sync="addFormShow"
      :teacherList="teacherList"
      v-show="addFormShow"
      ref="addGroupForm"
      @formSubmit="formSubmit"
      @multiple="multiple"
      @searchTeacher="searchTeacher"
      :groupTypeList="groupTypeList"
      :gradeSelectList="gradeSelectList"
      :courseList="courseList"
    />
  </div>
</template>

<script>
import groupList from "./group-list/groupList.vue";
import addGroupForm from "./addgroup-form/addgroup-form.vue";
import search from "@/components/search/search.vue";
export default {
  data() {
    return {
      queryData: {
        crowdName: "",
        status: 0,
      },
      addFormShow: false,
      groupListGetResult: "nullData",
      total: 1,
      selectList: [],
      teacherList: [],
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
      },
      groupData: [],
      teacherName: "",
      placeholder: "请输入分组名字",
      groupTypeList: [],
      gradeSelectList: [],
      courseList: [],
      //   data: {
      //     total: 1,
      //     rows: [
      //       {
      //         id: 9,
      //         createBy: "1",
      //         createTime: "2023-05-31 09:24:15",
      //         updateBy: null,
      //         updateTime: null,
      //         remark: null,
      //         delFlag: null,
      //         status: "0",
      //         searchValue: null,
      //         params: {},
      //         crowdName: "测试分组",
      //         crowdLeader: "某知名小学管理员",
      //         leaderId: 1,
      //         schoolId: 25,
      //         teacherCrowdList: null,
      //       },
      //     ],
      //     code: 200,
      //     msg: "查询成功",
      //   },
    };
  },
  provide() {
    return {
      refresh: this.getTeacherGroupList,
    };
  },
  components: {
    groupList,
    addGroupForm,
    search,
  },
  created() {
    this.getCourseList();
    this.getDictType();
    this.getTeacherGroupList();
    this.selectTeacherListByAdminPC();
    this.getGradeList();
  },
  methods: {
    // 科目列表
    getCourseList() {
      this.get(this.$url.getCourseList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log("获取学校科目==>",res);
          if (res.rows === null) {
            this.courseList = [];
            this.courseList = res.rows;
          }
          this.courseList = [];
          this.courseList = res.rows;
        })
        .catch((err) => {
          // this.getCourseListResult = "error";
          // this.$message.error("获取科目失败，请稍后再试");
        });
    },
    // 获取年级
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.gradeSelectList = res.data;
          } else {
            return this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          // console.log(err)
          // this.$message.error("获取年级信息失败，请稍后再试");
        });
    },
    getDictType() {
      this.get(`${this.$url.getDictType}/teacher_group_type`).then((res) => {
        this.groupTypeList = res.data;
      });
    },
    getTeacherGroupList() {
      // this.groupListGetResult = "loading";
      let { crowdName, status } = this.queryData;
      let schoolId = this.user.schoolId;
      let createBy = this.user.id;
      let leaderId = this.user.id;
      let crowdLeader = this.user.teacherName;
      this.get(this.$url.getTeacherGroupList, {
        crowdName,
        // crowdLeader,
        status,
        schoolId,
        // leaderId,
        // createBy,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      })
        .then((res) => {
          // console.log("获取教师分组==>", res);
          if (res.code != 200) {
            this.groupListGetResult = "error";
            return this.$message.error("获取分组列表失败");
          }
          this.groupData = res.rows;
          this.total = res.total;
          this.total > 0
            ? (this.groupListGetResult = "success")
            : (this.groupListGetResult = "nullData");
          if (this.total === 0) {
            this.groupListGetResult = "nullData";
            return this.$message.warning("暂无分组列表");
          }
        })
        .catch((err) => {
          console.log("获取教师分组报错==>", err);
        });
    },
    searchTeacher(e) {
      this.teacherName = e;
      this.selectTeacherListByAdminPC();
    },
    selectTeacherListByAdminPC() {
      this.post(this.$url.selectTeacherListByAdminPC, {
        schoolId: this.user.schoolId,
        teacherName: this.teacherName,
      })
        .then((res) => {
          //   console.log("获取教师列表==>", res);
          this.teacherList = res.rows;
        })
        .catch((err) => {
          console.log("获取教师列表err==>", err);
        });
    },
    multiple(data) {
      this.selectList = data;
    },
    search(query) {
      this.queryData.crowdName = query;
      // 刷新
      this.getTeacherGroupList();
    },
    // 批量删除
    deleteClick() {
      if (!this.selectList.length) {
        return this.$message.warning("请先选择需要删除的分组");
      }
      this.$confirm("是否删除选中的分组?", "删除分组", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除接口
          this.delete(this.$url.delTeacherGroup + "/" + this.selectList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.getTeacherGroupList();
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
    formSubmit(data) {
      const { groupName, type, gradeId, courseId } = data;
      // console.log(data);
      this.post(this.$url.addTeacherGroup, {
        crowdName: groupName,
        type: +data.type,
        gradeId,
        courseId,
        leaderId: this.selectList[0],
        schoolId: this.user.schoolId,
        teacherList: this.selectList, //教师id列表
      }).then((res) => {
        // console.log("新增分组==>", res);
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        this.$message.success(res.msg);
        this.$refs.addGroupForm.reset();
        this.addFormShow = false;
        this.getTeacherGroupList();
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageInfo.pageNum = pageNum;
      this.getTeacherGroupList();
    },
    handleSizeChange(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.getTeacherGroupList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacherGroup.scss";
</style>
